import type {SsoLinkEntry} from '@/state/slices/mediaSlice';

import {isSsoCookieFlowEnabledForLink, shouldRequestIccLoginTokenListSessionInfo} from './ssoIccSessionInfoPolicy';

export type ResolveSsoLinkUrlForOpenInput = {
    entry: Pick<SsoLinkEntry, 'url' | 'directUrl'>;
    openInBluefy: boolean;
    isSsoCookiesForced: boolean;
    isDcxMarket: boolean;
    lastSsoSessionApplyAt: number | null;
};

/**
 * Picks the URL to open from cached ICC data. Batch responses always carry `url` (ICC Url);
 * `directUrl` is used for DCX cookie flow only when cookies are already established.
 */
export const resolveSsoLinkUrlForOpen = ({
    entry,
    openInBluefy,
    isSsoCookiesForced,
    isDcxMarket,
    lastSsoSessionApplyAt,
}: ResolveSsoLinkUrlForOpenInput): string | undefined => {
    const {url, directUrl} = entry;

    if (!url) return undefined;

    if (!isSsoCookieFlowEnabledForLink({openInBluefy, isSsoCookiesForced}) || !isDcxMarket) return url;

    if (
        shouldRequestIccLoginTokenListSessionInfo({
            isDcxMarket: true,
            allowSessionInfo: true,
            lastSsoSessionApplyAt,
        })
    ) {
        return url;
    }

    return directUrl ?? url;
};
